const FourOhFourPage = () => 'oh no! four of hour!';

export default FourOhFourPage;
